module.exports = __webpack_public_path__ + "static/media/icone_tente.1531c11e.svg";